import { ENV_URLS } from '../../backend.config'
import { CrmBackendServers } from './CrmBackendServer'
import { IBackendServers, Languages } from '../../interfaces/common'
import { envEnum, getEnv } from '../../utils/crossEnv'
import { TEnvironment } from './envTypes'

const rawEnv = getEnv(envEnum.NEXT_PUBLIC_ENVIRONMENT)

const CURRENT_ENV = rawEnv as TEnvironment

export function getConnectionString(
  serverType: IBackendServers,
  language: Languages | undefined,
  path: string,
): string {
  const selectedLanguage = language ?? Languages.RU

  const isCrmServer = serverType === CrmBackendServers
  const serverName = isCrmServer ? 'CRM_BACKEND_SERVER' : 'AUTH_BACKEND_SERVER'
  const serverPortName = isCrmServer ? 'CRM_BACKEND_SERVER_PORT' : 'AUTH_BACKEND_SERVER_PORT'

  const baseURL = ENV_URLS[CURRENT_ENV][serverName][selectedLanguage]
  const port = ENV_URLS[CURRENT_ENV][serverPortName]

  let finalURL = baseURL

  if (!/^https?:\/\//.test(finalURL)) {
    finalURL = `https://${finalURL}`
  }

  if (port) {
    finalURL = `${finalURL}:${port}`
  }

  return `${finalURL}${path}`
}
